import React from "react";
import classNames from "classnames";
import { color, easingBounce, easingBounceMs } from "@ui";
import { styled } from "@linaria/react";
import { spacings } from "@ui/Theme";

const OPEN = "open";

const Container = styled.div``;

const Title = styled.p`
  cursor: pointer;
  color: ${color.carbon800};
  display: flex;
  align-items: center;
  padding: 4px;
  gap: ${spacings.xs};
  :before {
    display: block;
    content: "";
    width: 0.5em;
    height: 0.5em;
    border-width: 0 1px 1px 0;
    border-style: solid;
    transition: transform ${easingBounceMs}ms ${easingBounce};
    transform-origin: 60% 60%;
  }
  &:not(.${OPEN}):before {
    transform: rotate(-45deg);
  }
  &.${OPEN}:before {
    transform: rotate(45deg);
  }
`;

const ExpandedSection = styled.div`
  margin-top: 0;
  visibility: hidden;
  overflow: hidden;
  max-height: 0;

  &.${OPEN} {
    margin-top: 10px;
    max-height: 300px;
    visibility: visible;
    transition: all 0.1s linear;
    overflow: auto;

    /* hide scrollbar while animating */
    @keyframes hide-scroll {
      from,
      to {
        overflow: hidden;
      }
    }
    animation: 0.2s backwards hide-scroll;
  }
`;

interface P {
  title: string;
  expanded: boolean;
  handleClick?: () => void;
  className?: string;
  children: React.ReactNode;
  icon?: React.ReactNode; // Added icon prop
}

const SmallCollapseEditChanges = ({
  title,
  expanded,
  handleClick,
  className,
  children,
  icon,
}: P) => (
  <Container className={className}>
    <Title onClick={handleClick ?? undefined} className={classNames({ [OPEN]: expanded })}>
      {icon} {/* Render the icon if provided */}
      {title}
    </Title>
    <ExpandedSection className={classNames({ [OPEN]: expanded })}>{children}</ExpandedSection>
  </Container>
);

export default React.memo(SmallCollapseEditChanges);
